import { fetchWrapper } from "../utils/fetch-wrapper";

const individusService = {
  getAll,
  getAllClient,
  getById,
  post,
  delete: _delete,
  update,
};

function getAll(env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");
  return fetchWrapper.get(`individus/?${queryString}`);
}

function getAllClient(client_id: number) {
  return fetchWrapper.get(`individus/client/${client_id}`);
}

function getById(id) {
  return fetchWrapper.get(`individus/${id}`);
}

function post(data) {
  return fetchWrapper.post("individus/", data);
}

function update(id, params) {
  return fetchWrapper.put(`individus/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`individus/${id}`);
}

export default individusService;
